"use client"

import React from "react"
import { Navigate } from "react-router-dom"
import { useRestaurantAuth } from "../contexts/RestaurantAuthContext"

interface RestaurantProtectedRouteProps {
  children: React.ReactNode
}

const RestaurantProtectedRoute: React.FC<RestaurantProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useRestaurantAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/restaurant/login" replace />
  }

  return <>{children}</>
}

export default RestaurantProtectedRoute 